// removed by extract-text-webpack-plugin
module.exports = {"Table":"src-components-Admin-SuperAdmin-Table-__AdminTable-module___Table"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/SuperAdmin/Table/AdminTable.module.css
// module id = 1179
// module chunks = 1